import RestClient from './RestClient';
import { Log } from '../../models';
import Utils from '../Utils';

class Health extends RestClient {
    constructor() {
        super({
            "model": Log,
            "entryPoint": "health",
            "resource": "log",
            "resources": "logs"
        });
    }

    groupIcon(name) {
        switch (name) {
            case 'bucketlists':
                return 'battery-half';
            case 'screenings':
                return 'television';
            case 'tickettypes':
                return 'tags';
            case 'settings':
                return 'gear';
            case 'users':
                return 'users';
            case 'pdf_layouts':
                return 'file-pdf-o';
            case 'email_layouts':
                return 'envelope-o';
            case 'places':
                return 'th';
            case 'tasks':
                return 'tasks';
            default:
                return 'medkit';
        }
    }

    getLastCheck() {
        return this.GET(`/${this.entryPoint}/last_check`)
            .then(response => response.json())
            .then(json => {
                if (json.log) {
                    json.log= new Log(json.log);
                    return json;
                }
                throw new Error(json.flash.error);
            });
    }

    check() {
        return this.POST(`/${this.entryPoint}/check`)
            .then(response => response.json())
            .then(json => {
                if (json.log) {
                    json.log= new Log(json.log);
                    return json;
                }
                throw new Error(json.flash.error);
            });
    }
}

const HealthApi = new Health();

export default HealthApi;
